import React from "react";
import { motion } from "framer-motion";

const roles = [
  {
    title: "Startup",
    description: "Access funding, mentorship, and resources to accelerate your growth.",
    icon: "https://cdn.lordicon.com/jnzhohhs.json",
  },
  {
    title: "Investor",
    description: "Discover promising startups and diversify your investment portfolio.",
    icon: "https://cdn.lordicon.com/qhviklyi.json",
  },
  {
    title: "Mentor",
    description: "Share your expertise and guide the next generation of entrepreneurs.",
    icon: "https://cdn.lordicon.com/zpxybbhl.json",
  },
  {
    title: "Student",
    description: "Learn entrepreneurship skills and connect with potential co-founders.",
    icon: "https://cdn.lordicon.com/wxnxiano.json",
  },
  {
    title: "Freelancer",
    description: "Find projects that match your skills and build your client network.",
    icon: "https://cdn.lordicon.com/gqzfzudq.json",
  },
  {
    title: "HR",
    description: "Recruit top talent for your company from our pool of professionals.",
    icon: "https://cdn.lordicon.com/jxwksgwv.json",
  },
  {
    title: "Legal",
    description: "Provide legal services to startups and expand your client base.",
    icon: "https://cdn.lordicon.com/dqxvvqzi.json",
  },
  {
    title: "Incubation Center",
    description: "Partner with us to support startups and foster innovation.",
    icon: "https://cdn.lordicon.com/yxczfiyc.json",
  },
];

const ExploreRoles = () => {
  return (
    <>
      <script src="https://cdn.lordicon.com/lordicon.js"></script>

      <section className="px-4 py-16 md:py-20 lg:py-24 bg-white">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
            Explore Roles
          </h2>
          <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto mb-12">
            Find your perfect fit in the startup ecosystem. Each role offers unique benefits and opportunities.
          </p>

          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {roles.map((role, index) => (
              <motion.div
                key={index}
                className="bg-gray-50 p-6 rounded-xl shadow-sm hover:shadow-md transition duration-300"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              >
                <div className="flex justify-center mb-4">
                  <div className="bg-blue-100 p-3 rounded-full">
                    <lord-icon
                      src={role.icon}
                      trigger="loop"
                      delay="2000"
                      style={{ width: "40px", height: "40px" }}
                      colors="primary:#004a99"
                    ></lord-icon>
                  </div>
                </div>
                <h4 className="text-md font-semibold text-gray-800 mb-2 text-center">
                  {role.title}
                </h4>
                <p className="text-gray-600 text-sm text-center">
                  {role.description}
                </p>
                {/* <div className="text-blue-600 text-sm font-medium text-center mt-3">
                  Explore <span className="inline-block ml-1">&rarr;</span>
                </div> */}
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default ExploreRoles;
